import { RxQuestionMarkCircled } from '@react-icons/all-files/rx/RxQuestionMarkCircled'
import React from 'react'

import { PopoverWithClose } from '@disco/shared-components/ui/popover-with-close'

import { IconButton, Text } from 'components/ds'

type Props = {
  /** Accessible label for the trigger, e.g. "More info about ISWC" */
  label: string
  title?: string
  children: React.ReactNode
}

/**
 * Question mark icon button that opens a `PopoverWithClose` with help text.
 *
 * `m="1"` cancels the negative margin Radix gives ghost icon buttons, which
 * would otherwise swallow the gap between this and the label beside it.
 */
const InfoPopover = ({ label, title, children }: Props) => (
  <PopoverWithClose
    title={title}
    content={
      <Text as="p" size="2">
        {children}
      </Text>
    }
    width="260px"
  >
    <IconButton
      type="button"
      variant="ghost"
      color="gray"
      size="1"
      m="1"
      aria-label={label}
    >
      <RxQuestionMarkCircled size={16} />
    </IconButton>
  </PopoverWithClose>
)

export default InfoPopover
